import { getTranslations } from '@/lib/next-shim'
import { MapPinIcon, VideoCameraIcon, HomeIcon, ClipboardDocumentIcon } from '@heroicons/react/20/solid'

import { AvailabilityMeetingPlace } from '@/core/graphql/types'
import { useTranslations } from '@/lib/next-shim'

export function getMeetingPlaceIcon(meetingPlace: AvailabilityMeetingPlace) {
  switch (meetingPlace) {
    case AvailabilityMeetingPlace.VisioConference:
      return VideoCameraIcon
    case AvailabilityMeetingPlace.Center:
      return MapPinIcon
    case AvailabilityMeetingPlace.AtHome:
      return HomeIcon
    case AvailabilityMeetingPlace.SecondOpinion:
      return ClipboardDocumentIcon
  }
}

export function getMeetingPlaceLabel(meetingPlace: AvailabilityMeetingPlace, t: ReturnType<typeof useTranslations>) {
  switch (meetingPlace) {
    case AvailabilityMeetingPlace.VisioConference:
      return t('meetingPlace.visioConference')
    case AvailabilityMeetingPlace.Center:
      return t('meetingPlace.center')
    case AvailabilityMeetingPlace.AtHome:
      return t('meetingPlace.atHome')
    case AvailabilityMeetingPlace.SecondOpinion:
      return t('meetingPlace.secondOpinion')
  }
}
